import { createMuiTheme, Tooltip, withTheme, ThemeProvider } from "@material-ui/core";
import React from 'react';

const theme = createMuiTheme({
    overrides: {
        MuiTooltip: {
            arrow: {
                color: "white",
                border: `1px solid #000`,
            },
            tooltip: {
                backgroundColor: "white",
                border: `1px solid #000`,
                fontSize: 12,
                color: '#0D3C82',
            }
        }
    }
});

function TBTooltip(props) {
    const { children } = props;
    return (
        <ThemeProvider theme={theme}>
            <Tooltip {...props}>
                <div>
                    {children}
                </div>
            </Tooltip>
        </ThemeProvider>
    )
}

export default TBTooltip
